import { Component, OnInit, Inject, ViewChild, Input, ViewEncapsulation, ElementRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { EventInfo } from '../model/event.model';
import { EventDocumentInfo } from '../model/eventdocument.model';
import { ProjectDocumentInfo } from '../model/projectdocument.model';
import { IssueInfo } from '../model/issue.model';
import { IssueManagementComponent, summaryInfo, summarydetailInfo } from '../issue-management/issue-management.component'; //Add from lesson learned tab
import { GanttChartControlComponent } from "../gantt-chart-control/gantt-chart-control.component";
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { EffortGroupInfo } from '../model/effortgroup.model';
import { EffortPlanInfo } from '../model/effortplan.model';
import { BaselineInfo } from '../model/baseline.model';
import { GlobalService } from '../service/global.service';
import { Chart, ChartType, ChartOptions } from 'chart.js'; //Add from lesson learned tab
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts'; //Add from lesson learned tab

import { Observable } from 'rxjs';
import { DatePipe, Location } from '@angular/common';

import {
  HttpEventType,
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { async } from '@angular/core/testing';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { StateInfo } from '../model/StateInfo.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { EmpInfo } from '../model/emp.model';
import { ProjectSaleInfo } from '../model/projectsale.model';

let today = new Date().toISOString()

@Component({
  selector: 'app-effort-group',
  templateUrl: './effort-group.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./effort-group.component.css']
})
export class EffortGroupComponent implements OnInit {
  @ViewChild(GanttChartControlComponent) ganttchart;
  @Input() ProjectCode: string;
  @ViewChild('fileUploader') fileUploader: ElementRef;

  // Add from lesson learned tab
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };  

  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];

  // End Add from lesson learned tab

  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;
  ProjectPromise: Promise<ProjectInfo[]>  
  ProjectList: ProjectSaleInfo[]
  ProjectStatusList: LookupInfo[]  

  // flag display for Manager Only and not State Completed or terminate
  IsShowForThisManager: boolean;

  _ParamProjectCode: string
  _ParamProjectName: string
  _ParamCompanyName: string
  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;

  titlemodal: string
  detailmodal: string

  txtProjectCode: string
  txtProjectName: string
  txtProjectStart: string
  txtProjectEnd: string
  ddlProjectStatus: string
  ddlProjectStatusSavedraft: string

  hidProjectId: number
  public currentPageNumber: number
  public totalPages: number
  ProjectTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  txtProjectComment: string;

  // variable  Project Document Zone
  ProjectDocumentPromise: Promise<ProjectDocumentInfo[]>
  ProjectDocumentList: ProjectDocumentInfo[]
  ddlSupportContractType: string = null;
  ddlWarrantyType: string = null;
  ddlMAType: string = null;
  txtWarrantyStartDate: string = null;
  txtWarrantyEndDate: string = null;
  txtMAStartDate: string = null;
  txtMAEndDate: string = null;
  ddlPackage: number = null;

  SupportContractTypeList: any;
  WarrantyTypeList: any;
  MATypeList: any;
  ProjectPackageList: any;

  ddlSubscriptType: string = null;
  SubscriptTypeList: any;
  txtSubscriptionStartDate: string = null;
  txtSubscriptionEndDate: string = null;

  ddlPerputualType: string = null;
  PerputualTypeList: any;
  // End variable  Project Document Zone
  //ย้ายไป Event Component
  // Variable Lesson Learned Zone
  issueListAll: IssueInfo[]
  IssuePromise: Promise<IssueInfo[]>
  summaryInfo = new summaryInfo;

  IssueSummaryTotal: any

  lblbaselinestartdate: string;
  lblbaselineenddate: string;
  lblbaselinetotaldays: number;
  lblactualstartdate: string;
  lblactualenddate: string;
  lblactualtotaldays: number;
  lbloverduedays: number;
  totalticket: number;
  // End Variable Lesson Learned Zone

  // Variable Event Zone
  
  // End Variable Event Zone

  _RoleCode: string;

  // Dashboard variable
  inlineCheckboxBaselinePlan: boolean
  inlineCheckboxActualPlan: boolean
  SelectPlan: string = 'baseline,actual,';
  public TabProjectPlanIndex = 1;
  public TabOrganizationalIndex = 1;

  Stagelist: any;
  Actionlist: any;

  // Form Group
  EffortGroupForm: FormGroup;


  // Form Group for Assign Member
  AssignMemberForm: FormGroup;
  // array control Assign Member
  itemsAssignMemberForm_array: FormArray;
  // array of remove AssignMember
  //itemsRemoveAssignMember_array: ProjectMemberInfo[] = [];
  // Emp List for Assign Member
  EmployeeList: EmpInfo[] = [];
  // Lookup MASTERPROJECTROLE List for Assign Member
  PositionInProjectList: LookupInfo[] = [];

  // Assign Member Lead List
  AssignMemberLeadList: ProjectMemberInfo[] = [];

  // show only Manager
  IsShowForThisUserOtherManager: boolean;
  // Emp Manager current project
  EmpManager: string
  EmpManagerDisplayName: string


  // array control
  itemsSetup: FormArray;
  itemsBaseline: FormArray;

  BaselineList: BaselineInfo[];
  EffortGroupList: EffortGroupInfo[];

  // Org Chat
  filesToUpload: File[];
  pathImg: string = '';

  //Base line document
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';

  ListState: StateInfo[] = [];

  valuechange: boolean = false;

  async ngOnInit() {

    this.currentPageNumber = 1;
    this.TabProjectPlanIndex = 1;
    this.SetSelectTabProject(1);
    this.SetSelectTabOrganizational(1);
    this.inlineCheckboxBaselinePlan = true;
    this.inlineCheckboxActualPlan = true;

    
    this._EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode");
    this._RoleCode = !!this._EmpRoleCode ? this._EmpRoleCode : localStorage.getItem('EmpRoleCode');
    this._ParamProjectCode = !!this._ParamProjectCode ? this._ParamProjectCode : this.GetParam('ProjectCode').toString();

    // show only MANAGER
    this.IsShowForThisUserOtherManager = (this._RoleCode == "MANAGER" || this._RoleCode == "PROJECTCO");

    // Add from lesson learned tab
    Chart.defaults.global.legend.display = false;
    Chart.defaults.global.defaultFontSize = 18;
    // End Add from lesson learned tab

    await this.loadDDLSupportContractType().then((data) => {
      this.SupportContractTypeList = data
    });
    //await this.loadDDLWarrantyType().then((data) => {
    //  this.WarrantyTypeList = data
    //});
    //await this.loadDDLMAType().then((data) => {
    //  this.MATypeList = data
    //});
   await this.LoadStateList("3").then((data) => {
      this.WarrantyTypeList = data;
    });
    await this.LoadStateList("4").then((data) => {
      this.MATypeList = data
    });
    await this.LoadStateList("6").then((data) => {
      this.SubscriptTypeList = data
    });
    await this.LoadStateList("7").then((data) => {
      this.PerputualTypeList = data
    });

    await this.loadDDLPackage().then((data) => {
      this.ProjectPackageList = data
    });

    

    this.LoadProjectDetail();
    this.loadDDLStage();
    this.LoadStateList().then((data) => {
      this.ListState = data;
    });
   
    await this.loadDDLPriorty().then((data) => {
      this.Actionlist = data
    });
    // create control
    this.EffortGroupForm = await this.formBuilder.group({
      BaselineForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemBaselineDefault()])
      }) ,
      SetupForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemSetupDefault()])
      }),
      AssignMemberForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemAssignMemberDefault()])
      }) 
    });


    // set AssignMemberForm from InformationForm
    this.AssignMemberForm = this.EffortGroupForm.get('AssignMemberForm') as FormGroup

    // get items array to itemsAssignMemberForm_array
    this.itemsAssignMemberForm_array = this.AssignMemberForm.get('items') as FormArray;

    
    this.itemsBaseline = await this.EffortGroupForm.get('BaselineForm').get('items') as FormArray;
    this.itemsBaseline.clear();
    
    this.GetBaselineToBaseline();
    this.GetBaselineToSetUp();

    this.LoadIssueAll();
    // End Add from lesson learned tab
  }
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private router: Router, private location: Location) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
  }

  ///////////////////////////////////////Events////////////////////////////////////////////
  btnClick_showProjectList() {
  }

  ///////////////////////////////////////Functions/////////////////////////////////////////

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectDocument"]').prop('checked', check);

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  async LoadProjectDetail() {
    var auth_token = await this.TokenService.RefreshToken();
    this.loadDDLStatus(auth_token)
      .subscribe({
        next: data => {
          this.ProjectStatusList = data;
          if (this.ProjectStatusList.length) {
            // Get Project Detail
            this.LoadProjectList(auth_token)
              .subscribe({
                next: data => {
                  this.ProjectList = data;
                  if (this.ProjectList.length) {
                    this.isOnUpdate = true

                   

                    //this.ddlProjectStatus = this.ProjectList[0].ProjectStatusCode != null ? this.ProjectList[0].ProjectStatusCode : null
                    //this.ddlProjectStatusSavedraft = this.ddlProjectStatus;
                    //this.txtProjectCode = this.ProjectList[0].ProjectCode != null ? this.ProjectList[0].ProjectCode : null
                    this.txtProjectName = this.ProjectList[0].ProjectSaleName != null ? this.ProjectList[0].ProjectSaleName : null
                    //this.txtProjectStart = this.ProjectList[0].ProjectStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectStart) : null
                    //this.txtProjectEnd = this.ProjectList[0].ProjectEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectEnd): null

                    //this.ddlSupportContractType = this.ProjectList[0].ProjectSupportContractTypeCode != null ? this.ProjectList[0].ProjectSupportContractTypeCode : null

                    //this.ddlWarrantyType = this.ProjectList[0].ProjectWarrantyTypeCode != null ? this.ProjectList[0].ProjectWarrantyTypeCode : null
                    //this.ddlMAType = this.ProjectList[0].ProjectMATypeCode != null ? this.ProjectList[0].ProjectMATypeCode : null
                    //this.txtWarrantyStartDate = this.ProjectList[0].ProjectWarrantyStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectWarrantyStart) : null
                    //this.txtWarrantyEndDate = this.ProjectList[0].ProjectWarrantyEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectWarrantyEnd) : null
                    //this.txtMAStartDate = this.ProjectList[0].ProjectMAStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectMAStart) : null
                    //this.txtMAEndDate = this.ProjectList[0].ProjectMAEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectMAEnd) : null
                    //this.ddlPackage = this.ProjectList[0].ProjectPackage != null ? this.ProjectList[0].ProjectPackage : null
                    //this.pathImg = this.ProjectList[0].ProjectImgPath != null ? this.ProjectList[0].ProjectImgPath : null
                    //this.txtProjectComment = this.ProjectList[0].Comment != null ? this.ProjectList[0].Comment : null
                    //this.ddlSubscriptType = this.ProjectList[0].ProjectSubscriptType != null ? this.ProjectList[0].ProjectSubscriptType : null
                    //this.txtSubscriptionStartDate = this.ProjectList[0].ProjectSubscriptStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectSubscriptStart) : null
                    //this.txtSubscriptionEndDate = this.ProjectList[0].ProjectSubscriptEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectSubscriptEnd) : null
                    //this.hidProjectId = this.ProjectList[0].ProjectId

                    //this.ddlPerputualType = this.ProjectList[0].ProjectPerputualType != null ? this.ProjectList[0].ProjectPerputualType : null

                    if (this.pathImg != null) {
                      $('#previewImg').show();
                    } else {
                      $('#previewImg').hide();

                    }

                    this._ParamProjectName = this.txtProjectName;
                    //this._ParamCompanyName = this.ProjectList[0].ProjectCompanyName;

                    // flag display for Manager Only and not State Completed & terminate &  Waranty-Completed
                    //this.IsShowForThisManager = ((this.ProjectList[0].ProjectAssignPM == this.checkUndefinedString(localStorage.getItem("EmpCode")) || this.ProjectList[0].ProjectAssignPCO == this.checkUndefinedString(localStorage.getItem("EmpCode"))) && (this.ProjectList[0].ProjectStateCode != '0' && this.ProjectList[0].ProjectStateCode != '2-8' && this.ProjectList[0].ProjectStateCode != '3-2'))

                  }


                },
                error: error => {
                  console.error('There was an error!', error);
                }
              })

          }


        },
        error: error => {
          console.error('There was an error!', error);
        }
      })

    




  }

  async btnClick_submitUpdateProject(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      $('#ProjectDetailZone *').attr('disabled', 'true'); // set disable all control
      $('#loadingupdate').show(); // show button update loading
      $('#btnupdate').hide(); // hide button update

      id = this.hidProjectId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectCode'] = this.checkUndefinedString(this.txtProjectCode);
      objectjson['ProjectName'] = this.checkUndefinedString(this.txtProjectName);
      objectjson['ProjectStart'] = new Date(this.checkUndefinedString(this.txtProjectStart))
      objectjson['ProjectEnd'] = new Date(this.checkUndefinedString(this.txtProjectEnd))
      objectjson['ProjectStatusCode'] = this.ddlProjectStatus

      if (this.fileUploader.nativeElement.value == null) {
        objectjson['ProjectImgPath'] = null;
      } else {
        objectjson['ProjectImgPath'] = this.checkUndefinedString(this.pathImg);
      }
      
      if (this.ddlProjectStatus == '3') { // if status is complate
        objectjson['ProjectSupportContractTypeCode'] = this.ddlSupportContractType;
        if (this.ddlSupportContractType == "2") {
          //Waranty
          objectjson['ProjectStateCode'] = this.ddlMAType 
        } else if (this.ddlSupportContractType == "1") {
          //MA
          objectjson['ProjectStateCode'] = this.ddlWarrantyType
        } else if (this.ddlSupportContractType == "3") {
          //Perputation
          objectjson['ProjectStateCode'] = this.ddlPerputualType
        } else if (this.ddlSupportContractType == "4") {
          //Subscription
          objectjson['ProjectStateCode'] = this.ddlSubscriptType
        }
        
        objectjson['ProjectWarrantyTypeCode'] = this.ddlWarrantyType;
        objectjson['ProjectMATypeCode'] = this.ddlMAType;
        objectjson['ProjectWarrantyStart'] = new Date(this.checkUndefinedString(this.txtWarrantyStartDate))
        objectjson['ProjectWarrantyEnd'] = new Date(this.checkUndefinedString(this.txtWarrantyEndDate))
        objectjson['ProjectMAStart'] = new Date(this.checkUndefinedString(this.txtMAStartDate))
        objectjson['ProjectMAEnd'] = new Date(this.checkUndefinedString(this.txtMAEndDate))

        objectjson['ProjectSubscriptType'] = this.ddlSubscriptType
        objectjson['ProjectSubscriptStart'] = new Date(this.checkUndefinedString(this.txtSubscriptionStartDate))
        objectjson['ProjectSubscriptEnd'] = new Date(this.checkUndefinedString(this.txtSubscriptionEndDate))

        objectjson['ProjectPerputualType'] = this.ddlPerputualType

        objectjson['ProjectPackage'] = this.ddlPackage
      }


      objectjson['FlagDelete'] = "N";
      objectjson['ProjectId'] = id
      objectjson['UpdateBy'] = this._EmpCode;


      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/UpdateProject", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Update fail")
          $('#ProjectDetailZone *').removeAttr('disabled'); // unset disable all control
          $('#loadingupdate').hide(); // hide button update loading
          $('#btnupdate').show(); // show button update

          this.titlemodal = 'Update Project Detail Update fail.';
          this.detailmodal = 'Your project datail was Update fail.';
          $('#ModalError').modal();
        },
          () => {
            console.log("Update = " + this.isSubmitted)
            $('#ProjectDetailZone *').removeAttr('disabled'); // unset disable all control
            $('#loadingupdate').hide(); // hide button update loading
            $('#btnupdate').show(); // show button update

            this.titlemodal = 'Update Project Detail done.';
            this.detailmodal = 'Your project datail was updated successfully.';
            $('#ModalComplate').modal();
          }
        );
    }
  }

   loadDDLStatus(auth_token): Observable<LookupInfo[]> {
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"PROJECTSTATUS\" }";

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
    }
  }

  async selectedTabChange(traget) {
 
    if (traget.tab.textLabel == 'Effort (Plan)') {
      this.loadEffortGroup();
    } else if (traget.tab.textLabel == 'Document') {
    } else if (traget.tab.textLabel == 'Timeline & Project Plan') {  // Change Main tab (html) Label 'Dashboard' to 'Timeline & Project Plan'
      this.ganttchart.OnloadBaseline(false, this.SelectPlan);
      this.GetBaselineToBaseline();
      this.GetBaselineToSetUp();
    } else if (traget.tab.textLabel == 'Event') {
    } else if (traget.tab.textLabel == 'Project Plan') {
      this.OnClickBack();
      $($('mat-ink-bar')[1]).css("width", "160px");

    } else if (traget.tab.textLabel == 'Lesson Learned') { // Add from lesson learned tab
      //this.GetBaselineToLessonLearned(); // Add from lesson learned tab
    }                                    // Add from lesson learned tab
    else if (traget.tab.textLabel == 'Assign Member') {
      await this.ReLoadAssignMember();

    }

    
  }


  selectedTabChangeOrganizational(traget) {

    if (traget.tab.textLabel == 'Update Progress') {
    } else if (traget.tab.textLabel == 'Set up') {
    }


  }

  selectedTabChangeProjectPlan(traget) {

    if (traget.tab.textLabel == 'Update Progress') {
      this.GetBaselineToBaseline();
    } else if (traget.tab.textLabel == 'Set up') {
      this.GetBaselineToSetUp();
    } else if (traget.tab.textLabel == 'Dashboard') {
      this.ganttchart.OnloadBaseline(false, this.SelectPlan);
      this.GetBaselineToBaseline();
      this.GetBaselineToSetUp();
    } else if (traget.tab.textLabel == 'Timeline') {
      this.ganttchart.OnloadBaseline(false, this.SelectPlan);
    }


  }



  LoadProjectList(auth_token): Observable<ProjectSaleInfo[]> {
    //var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{\"ProjectSaleCode\": \"" + this.checkUndefinedString(this._ParamProjectCode) + "\", " +

        "\"rowFetch\": " + environment.PageSize + ", " +
        "\"rowOFFSet\": " + offset + ", " +
        "\"FlagDelete\": \"N\" " +
        "}";

      return this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale",
          strjson, httpOptions)
    }

  }
  async LoadStateList(cycleCode: string = "2"): Promise<StateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      var objectjson = {};
      objectjson['CycleCode'] = cycleCode
      objectjson['FlagActive'] = "Y"
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateInfo[]>(this.baseurl + "MasterSale/GetMappingStateStatusList", strjson, httpOptions)
        .toPromise()
    }
  }
 

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

 

  clearSearchSection() {

   
  }

  btnClick_deleteEffortGroup(id, auth_token): Observable<EffortPlanInfo[]> {


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    let arrayobjects = [];
    var objectjson = {};
    objectjson['EffortGroupId'] = id;
    objectjson['EffortGroupUpdateBy'] = this.checkUndefinedString(this._EmpCode);
    arrayobjects.push(objectjson);

    let strjsonCusInfo = JSON.stringify(arrayobjects);

    return this.httpClient.post<EffortPlanInfo[]>(this.baseurl + "EffortGroup/DeleteEffortGroup", strjsonCusInfo, httpOptions);
  }
  //// ---------------------- Event Detail Zone  -------------------------------
  //####### ย้ายไป Event Component ##########
  //// ---------------------- End Event Detail Zone  -------------------------------

  CheckboxPlanOnChange() {
    var checkbaseline = this.inlineCheckboxBaselinePlan;
    if (checkbaseline == true) {
      this.SelectPlan += 'baseline,';
    } else {
      this.SelectPlan =  this.SelectPlan.replace(new RegExp('baseline,', 'g'), '');
    }
    var checkboxactual = this.inlineCheckboxActualPlan;
    if (checkboxactual == true) {
      this.SelectPlan += 'actual,';
    } else {
      this.SelectPlan = this.SelectPlan.replace(new RegExp('actual,', 'g'), '');
    }
    this.ganttchart.OnloadBaseline(false, this.SelectPlan);


  }


    // ---------------------- Project Plan  Zone  -------------------------------



  async loadDDLStage() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"PROJECTPALNSTAGE\" }";

      this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.Stagelist = data
        });
    }
  }

  async loadDDLPriorty() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson["LookupType"] = "PROJECTPALNPRIORTY"
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadDDLSupportContractType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      //objectjson["LookupType"] = "PROJECTSUPPORTCONTRACTTYPE"
      objectjson["LookupType"] = "PROJECTSUPPORTCONTRACTTYPE"
      let strjson = JSON.stringify(objectjson);
      
      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }



  async loadDDLPackage() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";

      return await this.httpClient.post<any>(this.baseurl + "ProjectPackage/GetProjectPackage", strjson, httpOptions)
        .toPromise();
    }
  }

  async loadEffortGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EffortProjectSaleCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortGroupInfo[]>(this.baseurl + "EffortGroup/GetEffortGroup", strjson, httpOptions)
        .toPromise()
    }
  }

  GetBaselineToBaseline() {
    this.loadEffortGroup().then((data) => {
      this.EffortGroupList = data;

      this.itemsBaseline = this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
      this.itemsBaseline.clear();

      this.EffortGroupList.forEach((traget, indextraget) => {
        var actionlist = JSON.parse(JSON.stringify(this.Actionlist));
        this.itemsBaseline.push(this.createItemSetup(traget));
      });

    });
  }

  async GetBaselineToSetUp() {
    this.loadEffortGroup().then(async (data) => {
      this.EffortGroupList = data;


      this.itemsSetup = await this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
      this.itemsSetup.clear();

      this.EffortGroupList.forEach((traget, indextraget) => {
        this.itemsSetup.push(this.createItemSetup(traget));
      });

      this.valuechange = false;
    });
  }


  async btnClick_submitInsertEffortGroup() {
    debugger
    if (!this.itemsSetup.valid) return;
    /*if (this.EffortGroupForm.get('SetupForm').valid) {*/
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.loading(true, 'Saving ...');
        var flagremove = null;
        //remove old data
        //await this.RemoveoldEffortGroup().then((data) => {
        //  flagremove = data;
        //});
        

        if (true) {
          console.log('form submitted');
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          var listsetup = this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
          var listsetupcontrols = listsetup.controls;
          var arrayinsert = [];
          listsetupcontrols.forEach((itemcurrent) => {
            var objectjson = {};
            objectjson['EffortGroupId'] = Number(itemcurrent.value.EffortGroupId);
            objectjson['EffortProjectSaleCode'] = this._ParamProjectCode;
            objectjson['EffortGroupName'] = itemcurrent.value.EffortGroupName;
            objectjson['EffortGroupCreateBy'] = this.checkUndefinedString(this._EmpCode);
            objectjson['EffortGroupUpdateBy'] = this.checkUndefinedString(this._EmpCode);
            objectjson['EffortGroupFlagActive'] = "Y";
            objectjson['EffortGroupFlagDelete'] = "N";

            arrayinsert.push(objectjson);
          });



          let strjson = JSON.stringify(arrayinsert);

          this.isSubmitted = this.httpClient.post<any>(this.baseurl + "EffortGroup/InsertEffortGroup", strjson, httpOptions)

            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Insert fail")
              this.loading(false);

              this.titlemodal = 'Saving Effort Group fail.';
              this.detailmodal = 'Your effort group was saved fail.';
              $('#ModalError').modal();

            },
              () => {
                console.log("Insert = " + this.isSubmitted)
                this.loading(false);
                this.titlemodal = 'Saving Effort Group done.';
                this.detailmodal = 'Your effort group was updated successfully.';
                $('#ModalComplate').modal();
                console.log(this.ProjectCode);

                this.GetBaselineToSetUp();

                //this.selectedTabChange('Timeline & Project Plan');
                //this.ganttchart.OnloadBaseline(false, this.SelectPlan);
                //this.ngOnInit();
              }
            )
        } else {
          this.loading(false);

          this.titlemodal = 'Saving Effort Group fail.';
          this.detailmodal = 'Your effort group was saved fail.';
          $('#ModalError').modal();
          console.log('remove not complate')
        }

      }
    //} else {
    //  this.markFormGroupTouched(this.EffortGroupForm.get('SetupForm') as FormGroup);

    //}
  }

  async btnClick_UpdateProjectPlan() {
    if (this.EffortGroupForm.get('BaselineForm').valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form updatted');
        this.loading(true, 'Saving ...');

        console.log('form submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var listbaseline = this.EffortGroupForm.get('BaselineForm').get('items') as FormArray;
        var listbaselinecontrols = listbaseline.controls;
        var arrayinsert = [];
        listbaselinecontrols.forEach((itemcurrent) => {
          var objectjson = {};
          objectjson['BaselineId'] = itemcurrent.value.BaselineId;
          objectjson['BaselineActualStartDate'] = this.checkUndefinedDate(itemcurrent.value.BaselineActualStartDate);
          objectjson['BaselineActualEndDate'] = this.checkUndefinedDate(itemcurrent.value.BaselineActualEndDate);
          objectjson['BaselinePriorty'] = this.checkUndefinedString(itemcurrent.value.selectaction);
          objectjson['BaselineCreateBy'] = this.checkUndefinedString(this._EmpCode);
          objectjson['BaselineUpdateBy'] = this.checkUndefinedString(this._EmpCode);

          objectjson['BaselineProgress'] = itemcurrent.value.BaselineProgress;

          arrayinsert.push(objectjson);
        });



        let strjson = JSON.stringify(arrayinsert);

        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "Baseline/UpdateBaseline", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("update fail")
            this.loading(false);

            this.titlemodal = 'Saving Project Plan fail.';
            this.detailmodal = 'Your project plan was saved fail.';
            $('#ModalError').modal();

          },
            () => {
              console.log("update = " + this.isSubmitted)
              this.loading(false);
              this.titlemodal = 'Saving Project Plan done.';
              this.detailmodal = 'Your project plan was updated successfully.';

              $('#ModalComplate').modal();
              this.selectedTabChange('Timeline & Project Plan');
              this.ganttchart.OnloadBaseline(false, this.SelectPlan);
              //this.ganttchart.OnloadBaseline(false, this.SelectPlan);
            }
          )


      }
    } else {
      this.markFormGroupTouched(this.EffortGroupForm.get('BaselineForm') as FormGroup);

    }
  }

  async RemoveoldEffortGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"EffortProjectSaleCode\":\"" + this._ParamProjectCode + "\" }";

      return await this.httpClient.post<any>(this.baseurl + "EffortGroup/RemoveEffortGroup", strjson, httpOptions)
        .toPromise()
    }
  }

  async btnClick_deleteEffortGroupitem(id) {

    if (confirm("Do you want to delete this record?")) {
      let checkEffortGroupUsed = await this.CheckAlreadyUsedEffortGroup(id);
      if (!checkEffortGroupUsed) {
        debugger
        var currentEffortGroup = this.EffortGroupList.filter(x => { return x.EffortGroupId == id });
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {

          this.btnClick_deleteEffortGroup(parseInt(id), auth_token).toPromise()
            .then(
              data => {
                console.log('หลังรับค่า');
                //$('#ModalDeleteComplate').modal('show');
                this.GetBaselineToSetUp();
              }
            );
        }
      }
    }

  }

  async CheckAlreadyUsedEffortGroup(groupId) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      var objectjson = {};
      objectjson['EffortGroupId'] = Number(groupId);

      let strjson = JSON.stringify(objectjson);

      let result = await this.httpClient.post<any>(this.baseurl + "EffortGroup/CheckAlreadyUsedEffortGroup", strjson, httpOptions)
        .toPromise()
        .then(result => {
          if (result) {
            console.log("CheckAlreadyUsedEffortGroup = " + result);

            //Inform user
            this.titlemodal = '';
            this.detailmodal = 'This Effort Group is in use.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-blue');
            $('#ModalComplate').modal();
          }

          return result;
        })
        .catch(err => {
          console.log(err);
          return false;
        });

      return result;
    }
  }

  createAction(actionInputs) {
    const arr = actionInputs.map(action => {
      return new FormControl(action.selected || false);
    });
    return new FormArray(arr);
  }

  SetSelectTabProject(tabCount:number) {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % tabCount;
  }

  SetSelectTabOrganizational(tabCount: number) {
    this.TabOrganizationalIndex = (this.TabOrganizationalIndex + 1) % tabCount;
  }

  OnClickSetUp() {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % 3;
  }

  OnClickBack() {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % 2;
  }






  createItemSetupDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      EffortGroupId: [''],
      EffortGroupName: ['', Validators.required]
    }
    );
  }

  // validate custom
  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if (Date.parse(startcontrol.value) > Date.parse(endcontrol.value)) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }

  // validate custom
  checkdateActual(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if ((startcontrol.value == '' || startcontrol.value == null) && endcontrol.value != null && endcontrol.value != "" ) {
        startcontrol.setErrors({ needstartdate: true });
        startcontrol.markAsTouched();
        endcontrol.markAsTouched();

      } else {
        startcontrol.setErrors(null);
      }
    };
  }


  checkdatecurrent(
    controlName: string,
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];

      if (startcontrol.errors && !startcontrol.errors.checkdatecurrent) {
        return;
      }

      if (Date.parse(new Date().toDateString()) > Date.parse(startcontrol.value)) {
        startcontrol.setErrors({ checkdatecurrent: true });
      } else {
        startcontrol.setErrors(null);
      }
    };
  }

  createItemSetup(baselineitem: EffortGroupInfo): FormGroup {
    
    return this.formBuilder.group({
      ProjectCode: [''],
      EffortGroupName: [baselineitem.EffortGroupName, Validators.required],
      EffortGroupId: [baselineitem.EffortGroupId]
    },
      {
        // Used custom form validator 
        //validator: [this.checkdate("BaselineStartDate", "BaselineEndDate")]
      }
    );
  }

  createItemBaselineDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      BaselineTaskName: [''],
      BaselineTaskNameDisplay: [''],
      BaselineType: [null],
      BaselineTypeDisplay: [''],
      BaselineStartDate: [''],
      BaselineEndDate: [''],
      BaselineRemark: [''],
      BaselineActualStartDate: [''],
      BaselineActualEndDate: [''],
      BaselinePriorty: [''],
      BaselineProgress: ['']
    },
      {
        // Used custom form validator 
        validator: [this.checkdateActual("BaselineActualStartDate", "BaselineActualEndDate"), this.checkdate("BaselineActualStartDate", "BaselineActualEndDate")]
      }
    );
  }

  createItemBaseline(baselineitem: BaselineInfo, actionlist): FormGroup {
    
    return this.formBuilder.group({
      ProjectCode: [''],
      BaselineId: [baselineitem.BaselineId],
      BaselineTaskName: [baselineitem.BaselineTaskName],
      BaselineTaskNameDisplay: [baselineitem.BaselineTaskNameDisplay],
      BaselineType: [baselineitem.BaselineType],
      BaselineTypeDisplay: [baselineitem.BaselineTypeDisplay],
      BaselineStartDate: [this.ConvertDatetoDatetime(baselineitem.BaselineStartDate)],
      BaselineEndDate: [this.ConvertDatetoDatetime(baselineitem.BaselineEndDate)],
      BaselineRemark: [baselineitem.BaselineRemark],
      BaselineActualStartDate: [this.ConvertDatetoDatetime(baselineitem.BaselineActualStartDate)],
      BaselineActualEndDate: [this.ConvertDatetoDatetime(baselineitem.BaselineActualEndDate)],
      BaselinePriorty: this.createAction(actionlist),
      selectaction: [baselineitem.BaselinePriorty],
      BaselineProgress: [baselineitem.BaselineProgress]
    },
      {
        // Used custom form validator 
        validator: [this.checkdateActual("BaselineActualStartDate", "BaselineActualEndDate"), this.checkdate("BaselineActualStartDate", "BaselineActualEndDate")]
      }
    );
  }

  addItem(): void {

    this.itemsSetup = this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
    this.itemsSetup.push(this.createItemSetupDefault());
  }

  removeItem(indexitem): void {
    this.itemsSetup = this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
    this.itemsSetup.removeAt(indexitem);
  }

  getvalueselect(traget, index) {
    this.itemsBaseline = this.EffortGroupForm.get('BaselineForm').get('items') as FormArray;

    var checked = traget.checked; // true mean cheked
    if (checked == true) {
      var indextraget = this.Actionlist.findIndex(x => x.LookupCode == traget.value);
      var Actionall = this.itemsBaseline.controls[index].value.BaselinePriorty;
      for (var i = 0; i < Actionall.length; i++) {
        if (i != indextraget) {
          var controlsgroup = this.itemsBaseline.controls[index] as FormGroup;
          var contraolarray = controlsgroup.controls.BaselinePriorty as FormArray;
          // set checkbox
          contraolarray.controls[i].setValue(false);
        }
      }
    } else {
      this.itemsBaseline.controls[index].value.selectaction = '';

    }


    var actionselect = this.itemsBaseline.controls[index].value.BaselinePriorty.findIndex(x => x == true);
    if (actionselect != -1) {
      this.itemsBaseline.controls[index].value.selectaction = this.Actionlist[actionselect].LookupCode;
    } else {
      this.itemsBaseline.controls[index].value.selectaction = '';

    }
  }

  // set end date = start date when select stage = Milestone
  BaselineStageChange(traget) {
    var current = traget.currentTarget;
    var currentselecttext = $(current).find('option:selected').text().trim();
    if (currentselecttext == 'Milestone') {
      var indexcontrol = $(current).attr('index');
      var FormArray = this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
      var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

      if (controlsgroup.controls.BaselineStartDate.value != '' && controlsgroup.controls.BaselineStartDate.value != null) {
        controlsgroup.controls.BaselineEndDate.setValue(controlsgroup.controls.BaselineStartDate.value);
      }
    }
    

  }


    // set end date = start date when select stage = Milestone  (On start date change)
  BaselineStartDateChange(traget) {
    var current = traget.currentTarget;
    var indexcontrol = $(current).attr('index');
    var FormArray = this.EffortGroupForm.get('SetupForm').get('items') as FormArray;
    var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

    // if Base line Stage = Milestone
    if (controlsgroup.controls.BaselineType.value == '4') {
      if (controlsgroup.controls.BaselineStartDate.value != '' && controlsgroup.controls.BaselineStartDate.value != null) {
        controlsgroup.controls.BaselineEndDate.setValue(controlsgroup.controls.BaselineStartDate.value);
      }
    }

   


  }



  // set end date = start date when select stage = Milestone  (On start date change)
  BaselineActualStartDateChange(traget) {
    var current = traget.currentTarget;
    var indexcontrol = $(current).attr('index');
    var FormArray = this.EffortGroupForm.get('BaselineForm').get('items') as FormArray;
    var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

    // if Base line Stage = Milestone
    if (controlsgroup.controls.BaselineTypeDisplay.value == 'Milestone') {
      if (controlsgroup.controls.BaselineActualStartDate.value != '' && controlsgroup.controls.BaselineActualStartDate.value != null) {
        controlsgroup.controls.BaselineActualEndDate.setValue(controlsgroup.controls.BaselineActualStartDate.value);
      }
    }


  }


      // ---------------------- End Project Plan  Zone  -------------------------------

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  ConvertDatetoDatetime(DateValue) {
    if (DateValue) {
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ];
      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daydisplay = day.toString();
      if (day < 10) {
        daydisplay = '0' + day
      }

      var monthIndex = date.getMonth()+1;
      var monthisplay = monthIndex.toString();
      if (monthIndex < 10) {
        monthisplay = '0' + monthIndex
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();

      var Datenow = '';

      Datenow = year + "-" + monthisplay + "-" + daydisplay;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }


  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }


  selectFileOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.filesToUpload = ss.currentTarget.files;
    $("#file").val(fileName);
    const reader = new FileReader();
    reader.onload = () => {
      this.pathImg = reader.result as string;
    }
    // read the image file as a data URL.
    reader.readAsDataURL(ss.currentTarget.files[0]);
    $('#previewImg').show();
  }

  btnClick_selectFile(traget) {
    var file = $(traget.currentTarget).parents().find(".file");
    file.trigger("click");
  }

  chartClicked(traget) {

  }

  LoadIssueAll() {

    this.LoadIssueList(true)
      .then(
        data => {
          this.issueListAll = data;
          this.IssueSummaryTotal = data.filter(x => x.IssueStatusName != "Closed").length;
          this.summaryInfo.sumPriorityL = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low").length;
          this.summaryInfo.sumPriorityM = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium").length;
          this.summaryInfo.sumPriorityH = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High").length;

          this.summaryInfo.sumSeverityL = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Minor").length;
          this.summaryInfo.sumSeverityM = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Major").length;
          this.summaryInfo.sumSeverityH = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Critical").length;

          this.summaryInfo.sumStatusOpen = data.filter(x => x.IssueStatusName == "Open").length;
          this.summaryInfo.sumStatusInprogress = data.filter(x => x.IssueStatusName == "In Progress").length;
          this.summaryInfo.sumStatusClosed = data.filter(x => x.IssueStatusName == "Closed").length;
          this.summaryInfo.sumStatusNew = data.filter(x => x.IssueStatusName == "New").length;
          this.summaryInfo.sumStatusHold = data.filter(x => x.IssueStatusName == "Hold").length;

          this.summaryInfo.PriorityLList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low");
          this.summaryInfo.PriorityMList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium");
          this.summaryInfo.PriorityHList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High");
          this.summaryInfo.SeverityLList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Low");
          this.summaryInfo.SeverityMList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Medium");
          this.summaryInfo.SeverityHList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "High");
          this.pieChartLabels = ['Open', 'In Progress', 'Hold', 'Closed']
          this.pieChartData = [this.summaryInfo.sumStatusOpen, this.summaryInfo.sumStatusInprogress, this.summaryInfo.sumStatusHold, this.summaryInfo.sumStatusClosed];
          this.pieChartColors[0].backgroundColor = ['#6ae7d8', '#6a8fef', '#e8a362', '#5f5e5e'];

          this.totalticket = this.summaryInfo.sumStatusOpen + this.summaryInfo.sumStatusInprogress + this.summaryInfo.sumStatusHold + this.summaryInfo.sumStatusClosed
        }
    )    
  }

  async LoadIssueList(Getall: boolean = false): Promise<IssueInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      // Update variable for pagination from pagination control
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      objectjson['FlagDelete'] = "N";

      if (Getall == true) {
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;

      }

      let strjson = JSON.stringify(objectjson);
      this.IssuePromise = this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetIssueCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.IssuePromise;
    }
  }

  GroupAndSumStatusIssue(list) {
    var result = [];
    list.reduce(function (res, value) {
      if (!res[value.IssueOwnerCode]) {
        res[value.IssueOwnerCode] = { ActionOwner: value.IssueOwnerName, IssueOwnerCode: value.IssueOwnerCode, IssueOwnerNickName: value.IssueOwnerNickName, IssueAmount: 0, PriorityHigh: 0, PriorityMedium: 0, PriorityLow: 0, SeverityHigh: 0, SeverityMedium: 0, SeverityLow: 0 };
        result.push(res[value.IssueOwnerCode])
      }
      res[value.IssueOwnerCode].IssueAmount += 1;

      if (value.PriorityCode == "1") {
        res[value.IssueOwnerCode].PriorityLow += 1;
      }
      if (value.PriorityCode == "2") {
        res[value.IssueOwnerCode].PriorityMedium += 1;
      }
      if (value.PriorityCode == "3") {
        res[value.IssueOwnerCode].PriorityHigh += 1;
      }
      if (value.SeverityCode == "1") {
        res[value.IssueOwnerCode].SeverityLow += 1;
      }
      if (value.SeverityCode == "2") {
        res[value.IssueOwnerCode].SeverityMedium += 1;
      }
      if (value.SeverityCode == "3") {
        res[value.IssueOwnerCode].SeverityHigh += 1;
      }
      return res;
    }, {});

    return result;
  }

  async SaveProjectComment() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectId'] = this.hidProjectId;
      objectjson['Comment'] = this.txtProjectComment;

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/UpdateProject", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)

            $('#ModalSaveCommentComplete').modal();
          }
        );
    }
  }

  // End Add from lesson learned tab
  OnClickConfirmSaveBaselineFile() {
    this.UploadFilesToServer(this.baselineFilesToUpload);
  }

  OnBtnClearClick() {
    $('#txtSchFileName').val('');
  }

  resetFileUploader() {
    this.fileUploader.nativeElement.value = null;
    this.pathImg == null;
      $('#previewImg').hide();

  }

  /******************************* Upload file ********************************/
  DragFilesFinished(returnObj) {
    ;
    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.baselineFilesToUpload = returnObj.Files;
      this.baselinePathFile = returnObj.PathFile;
    }
  }

  UploadFilesToServer(files) {
    
    if (files.length === 0) {
      alert("Please browse file at least one.")
      return;
    }
    let filesToUpload: File[] = files;

    Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {

          }
        });


    });

  }
/******************************* Upload file ********************************/

/******************************* Event Upload file ********************************/
  async UploadEventFilesToServer(files) {
    
    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
              // check upload count
            }

          } else if (event.type === HttpEventType.Response) {

          }
        });



    });

    return true;
  }
  /******************************* End Event Upload file ********************************/


  // ----------------------- Function Assign Member Zone -----------------------------------------
  createItemAssignMemberDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [null],
      EmpName: [null, Validators.required],
      EmpNameDisplay: [null],
      PositionInProject: [null],
      PositionInProjectDisplay: [null],
      JobTitle: [null],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }

  createItemAssignMember(ProjectMemberitem: ProjectMemberInfo): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [ProjectMemberitem.Id],
      EmpName: [ProjectMemberitem.EmpCode, Validators.required],
      EmpNameDisplay: [ProjectMemberitem.EmpNameDisplay],
      PositionInProject: [''],
      PositionInProjectDisplay: [''],
      JobTitle: [''],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }


  async loadAssignMemberProject() {
    // clear old
    this.itemsAssignMemberForm_array.clear();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = 'Project';

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/GetProjectMember", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emp manager cuurent project
          var listempmanager = data.filter(function (obj) {
            return obj.PositionInProject == '1';
          });

          if (listempmanager.length) {
            this.EmpManager = listempmanager[0].EmpCode;
            this.EmpManagerDisplayName = listempmanager[0].EmpNameDisplay;
          }

          // Remove Lookup Project Manager from data on object property LookupCode = 1
          data = data.filter(function (obj) {
            return obj.PositionInProject !== '1';
          });
         

          this.AssignMemberLeadList = data;

          // if not empty Assign Member set default and Current User is Manager
          if (this.AssignMemberLeadList.length <= 0 && this.IsShowForThisManager == true) {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
          }

        });
    }
  }

  async loadEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emplist for assign member without cuurent manager && member is internal
          this.EmployeeList = data.filter(obj => {
            return obj.EmpCode !== this.EmpManager && obj.EmpType == '1';
          });

          // load detail emp for assign member

          this.AssignMemberLeadList.forEach((traget, indextraget) => {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMember(traget));
            //load detail of Emp
            this.onChanges(indextraget)
          });
        });
    }
  }

  addAssignMemberItem(): void {
    this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
  }

  removeAssignMemberItem(indexitem): void {
    // get id cuurent AssignMember
    var cuurentIdAssignMember = this.itemsAssignMemberForm_array.at(indexitem).value.ProjectMemberId;

    if (cuurentIdAssignMember != null) {
      // set FlagRemove Assign Member
      this.itemsAssignMemberForm_array.at(indexitem).value.FlagRemove = true;
    } else {
      // remove from Array
      this.itemsAssignMemberForm_array.removeAt(indexitem);
    }


  }

  // get count remove Assign Member for Display No.
  getcountremove() {
    return this.itemsAssignMemberForm_array.controls.filter(function (obj) {
      return obj.value.FlagRemove === true;
    }).length;
  }

  async onChanges(idx, checkForDuplicate: boolean = false) {
    //this.selectEmpName = empcode;
    var empcode = this.itemsAssignMemberForm_array.controls[idx].get('EmpName').value;

    var duplicate: boolean = false;
    if (checkForDuplicate) {
      var listcontrols = this.itemsAssignMemberForm_array.controls;
      listcontrols.forEach((itemcurrent, index) => {
        if (itemcurrent.value.EmpName == empcode && index != idx) {
          duplicate = true;
        }
      });

    }


    if (!duplicate) {
      var jobtitle = this.EmployeeList.find(x => { return x.EmpCode == empcode }).JobTitle;
      var position = this.EmployeeList.find(x => { return x.EmpCode == empcode }).PositionName;
      var nickname = this.EmployeeList.find(x => { return x.EmpCode == empcode }).NickName;
      var mobile = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mobile;
      var mails = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mail;
      //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionCode;
      //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionName;

      var EmpJobTitle = this.itemsAssignMemberForm_array.controls[idx].get('JobTitle');
      var EmpPosition = this.itemsAssignMemberForm_array.controls[idx].get('PositionInProjectDisplay');
      var EmpNickname = this.itemsAssignMemberForm_array.controls[idx].get('NickName');
      var EmpPhone = this.itemsAssignMemberForm_array.controls[idx].get('Phone');
      var EmpMail = this.itemsAssignMemberForm_array.controls[idx].get('Email');

      EmpJobTitle.setValue(jobtitle);
      EmpPosition.setValue(position);
      EmpNickname.setValue(nickname)
      EmpPhone.setValue(mobile)
      EmpMail.setValue(mails)
    } else {
      this.removeAssignMemberItem(idx);
      this.addAssignMemberItem();
      alert("You cannnot select duplicate employee.");
    }
  }


  async ReLoadAssignMember() {
    // set to default
    this.AssignMemberForm.markAsUntouched();

    // ------------------- Assign Member Zone -------------------------------
    // Load Assgin Member
    await this.loadAssignMemberProject();
    // Load Emp List for Assign Member
    await this.loadEmpList();
    //Load PositionInProject (Lookup MASTERPROJECTROLE) for Assgin Member
    await this.GlobalService.loadLookup('MASTERPROJECTROLE').then((data) => {
      // Remove Lookup Project Manager from data on object property LookupCode = 1
      data = data.filter(function (obj) {
        return obj.LookupCode !== '1';
      });

      this.PositionInProjectList = data;
    });

 
    // ------------------- Assign Member Zone -------------------------------
  }

  async btnClick_submitSaveAssignMember() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (this.AssignMemberForm.valid) {
        console.log('SaveAssignMember submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var listcontrols = this.itemsAssignMemberForm_array.controls;
        var arrayinsert = [];
        listcontrols.forEach((itemcurrent) => {
          var objectjson = {};

          objectjson['Id'] = itemcurrent.value.ProjectMemberId;
          objectjson['ProjectCode'] = this._ParamProjectCode;
          objectjson['ProjectType'] = "Project";
          objectjson['EmpCode'] = itemcurrent.value.EmpName;

          var EmpRole = this.EmployeeList.find(x => { return x.EmpCode == itemcurrent.value.EmpName }).RoleCode;

          objectjson['EmpRole'] = EmpRole;
          //objectjson['PositionInProject'] = itemcurrent.value.PositionInProject;
          objectjson['FlagRemoveAssignMemberFromClient'] = itemcurrent.value.FlagRemove;

          objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          arrayinsert.push(objectjson);
        });

        let strjson = JSON.stringify(arrayinsert);
        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectMember/UpdateAssignMemberProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("SaveAssignMember fail")
            this.titlemodal = 'Save Assign Member fail.';
            this.detailmodal = 'Save Assign Member was saved fail.';
            $('#ModalError').modal();
          },
            async () => {
              console.log("SaveAssignMember = " + this.isSubmitted)
              await this.ReLoadAssignMember();
              this.loading(false);
              this.titlemodal = 'Saving Assign Member done.';
              this.detailmodal = 'Your member was updated successfully.';
              $('#ModalComplate').modal();
            }
          )

      } else {
        this.GlobalService.markFormGroupTouched(this.AssignMemberForm);
      }
    }
  }



    // ----------------------- Function Assign Member Zone -----------------------------------------

  btnClick_editing(id) {
    $('#EffortGroupName' + id).removeAttr('readonly');
    $("#btncreateplan" + id).attr('disabled', 'disabled');
    //btncreateplan
  }

  btnClick_planning(id, name) {
    this.router.navigate(["/effort-plan", { ProjectSaleCode: this._ParamProjectCode, EffortGroupId: id, EffortGroupName: name }]);
  }

  valuechanged() {
    this.valuechange = true;
  }

  GoBack() {
    if (this.valuechange == true) {
      confirm("Do you want to go back to previous page?") ? this.location.back() : false;
    } else {
      this.location.back()
    }
  }
}
